(function () {
  'use strict';

  function toggleSection(btn) {
    var section = btn.closest('.m_sectionWithAccordion');
    if (!section) return;

    var panel = section.querySelector('.m_mobAccordionPanel');
    if (!panel) return;

    var isCollapsed = section.classList.contains('m_toggleSection');

    if (isCollapsed) {
      section.classList.remove('m_toggleSection');
      btn.classList.add('active');
      panel.style.display = 'block';
    } else {
      section.classList.add('m_toggleSection');
      btn.classList.remove('active');
      panel.style.display = 'none';
    }
  }

  function initAccordion(scope) {
    var root = scope || document;
    if (!root.querySelector('.pdp-revamp--active')) return;

    root.querySelectorAll('.m_mobAccordionBtn').forEach(function (btn) {
      if (btn.dataset.pdpAccordionInit === 'true') return;
      btn.dataset.pdpAccordionInit = 'true';
      btn.addEventListener('click', function () {
        toggleSection(btn);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAccordion();
    });
  } else {
    initAccordion();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAccordion(event.target);
  });
})();
